/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./image.component";
import * as i2 from "../../universal-config";
var styles_ImageComponent = [];
var RenderType_ImageComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_ImageComponent, data: {} });
export { RenderType_ImageComponent as RenderType_ImageComponent };
export function View_ImageComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, "img", [], [[8, "src", 4]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.fileServerUrl + _co.attachment.attachmentURL); _ck(_v, 0, 0, currVal_0); }); }
export function View_ImageComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "nns-image", [], null, null, null, View_ImageComponent_0, RenderType_ImageComponent)), i0.ɵdid(1, 49152, null, 0, i1.ImageComponent, [i2.Config], null, null)], null, null); }
var ImageComponentNgFactory = i0.ɵccf("nns-image", i1.ImageComponent, View_ImageComponent_Host_0, { attachment: "attachment" }, {}, []);
export { ImageComponentNgFactory as ImageComponentNgFactory };
//# sourceMappingURL=image.component.ngfactory.js.map